import { useIsMobile } from './useIsMobile';

export function useMediaQuery(query: string): boolean {
  return useIsMobile(query);
}
